/**
 * emailForm.js
 * import axios for server calls
 * import Form is used for form fields and styling
 * import Button is the button field from react bootstrap
 */
import React, {useState} from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import { Form } from 'react-bootstrap';
import "../../style/creationstyle.css";
/**
 * @param eventDeatils = a event details for getting info about the event
 */
function EmailForm({eventDetails}) {
    const [editorMessage, setEditorMessage] = useState("");
    /**
     * sends a message to contacts that have been invited to the event 
     */
    async function sendMessage(e) {
        e.preventDefault();
        const formData = new FormData();
        formData.append('message', editorMessage);
        axios.put(`https://link2rsvp.herokuapp.com/event/message/${eventDetails._id}`, {editorMessage});
    
        clearEditor();
    }
    /**
     * clears editor
     */
    function clearEditor() {
        setEditorMessage("");
        eventDetails = null;
    }

    return (
        <div className="messageComponent">
            <Form onSubmit={sendMessage} encType="multipart/form-data">
                <Form.Group className="mb=3">
                    <Form.Control as="textarea" rows={5}
                    placeholder="Message invited contacts."
                    id="mesg-cons"
                    type="text"
                    value={editorMessage}
                    onChange={(e) => setEditorMessage(e.target.value)}
                    />
                </Form.Group>
                <Button type='submit' variant='secondary' id="mesg-cons-btn" style={{backgroundColor: "#890E32"}}>Send Message</Button>
            </Form>
        </div>
    )
}
export default EmailForm;